import { render, staticRenderFns } from "./RangeSliderHandle.vue?vue&type=template&id=64328d8a&scoped=true&"
import script from "./RangeSliderHandle.vue?vue&type=script&lang=js&"
export * from "./RangeSliderHandle.vue?vue&type=script&lang=js&"
import style0 from "./RangeSliderHandle.vue?vue&type=style&index=0&id=64328d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64328d8a",
  null
  
)

export default component.exports